import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/components/pages/Homepage.vue'
import Crm from '@/components/pages/Crm.vue'
import Hrm from '@/components/pages/Hrm.vue'

import Single from '@/components/pages/Post.vue'

import Page from '@/components/pages/Page.vue'
import Contact from '@/components/pages/Contact.vue'

import myPosts from '@/components/pages/myPosts.vue'
import Faq from '@/components/pages/Faq.vue'
import FaqSingle from '@/components/pages/FaqSingle.vue'

import CategoryPage from '@/components/pages/CategoryPage.vue'
import Author from '@/components/pages/Author.vue'
import Search from '@/components/pages/Search.vue'
import Archives from '@/components/pages/Archives.vue'
import NotFoundPage from '@/components/pages/404.vue'

import Documenten from '@/components/pages/Documenten.vue'
import Rapportage from '@/components/pages/Rapportage.vue'
import Cloudcomputing from '@/components/pages/Cloud-computing.vue'
import Hosting from '@/components/pages/Hosting.vue'
import Beheer from '@/components/pages/Beheer.vue'
import Support from '@/components/pages/Support.vue'
import Consultancy from '@/components/pages/Consultancy.vue'
import Implementatie from '@/components/pages/Implementatie.vue'
import Workflow from '@/components/pages/Workflow.vue'

import Exactsoftware from '@/components/pages/Exact-software.vue'
import Cassoftware from '@/components/pages/Cas-software.vue'
import Elvysoftware from '@/components/pages/Elvy-software.vue'
import Sumatra from '@/components/pages/Sumatra.vue'
import Qics from '@/components/pages/Qics.vue'


import Vuelidate from "vuelidate";


Vue.use(Router)
Vue.use(Vuelidate);

// src/router.js
const router = new Router({
  // What you previously had here, such as routes

  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

/*
router.beforeEach((to, from, next) => {

  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
      .forEach(tag => document.head.appendChild(tag));

  next();
});
*/


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Homepage',
      component: Homepage,
      meta: {
        title: 'About Page - Example App'
      }

    },

    {
      name: 'Login',
      path: '/login',
      component: Page
    },

    {
      name: 'Over-yoursource',
      path: '/over-yoursource',
      component: Page
    },

    {
      name: 'Crm',
      path: '/crm',
      component: Crm
    },

    {
      name: 'Hrm',
      path: '/hrm',
      component: Hrm
    },

    {
      name: 'Workflow',
      path: '/workflow',
      component: Workflow
    },

    {
      name: 'Documenten',
      path: '/documenten',
      component: Documenten
    },

    {
      name: 'Rapportage',
      path: '/rapportage',
      component: Rapportage
    },

    {
      name: 'Cloud-computing',
      path: '/cloud-computing',
      component: Cloudcomputing
    },



    {
      name: 'Exact software',
      path: '/exact-software',
      component: Exactsoftware
    },

    {
      name: 'Cas software',
      path: '/cas-software',
      component: Cassoftware
    },

    {
      name: 'Elvy software',
      path: '/elvy-software',
      component: Elvysoftware
    },

    {
      name: 'Sumatra',
      path: '/sumatra',
      component: Sumatra
    },

    {
      name: 'Qics',
      path: '/qics',
      component: Qics
    },

    {
      name: 'Hosting',
      path: '/hosting',
      component: Hosting
    },

    {
      name: 'Beheer',
      path: '/beheer',
      component: Beheer
    },


    {
      name: 'Implementatie',
      path: '/implementatie',
      component: Implementatie
    },

    {
      name: 'Consultancy',
      path: '/consultancy',
      component: Consultancy
    },


    {
      name: 'myPosts',
      path: '/myPosts',
      component: myPosts
    },



    {
      name: 'Archives',
      path: '/archives',
      component: Archives
    },

    {
      name: 'Contact',
      path: '/contact',
      component: Contact
    },

    {
      name: 'Category',
      path: '/c/:categorySlug',
      component: CategoryPage
    },

    {
      name: 'Author',
      path: '/author/:authorId',
      component: Author
    },

    {
      name: 'Search',
      path: '/search/:searchTerm',
      component: Search
    },



    {
      name: 'Veel gestelde vragen',
      path: '/veel-gestelde-vragen',
      component: Faq
    },


    {
      name: 'faqitem',
      path: '/faq/:postSlug',
      component: FaqSingle
    },


    {
      name: 'SignUp',
      path: '/sign-up',
      component: Page
    },

    {
      name: 'About',
      path: '/about',
      component: Page
    },

    {
      name: 'Support',
      path: '/support',
      component: Page
    },

    {
      name: 'SearchDate',
      path: '/search-date',
      component: Search
    },

    {
      name: 'post',
      path: '/:postSlug',
      component: Single
    },

    {
      name: 'NotFound',
      path: '*',
      component: NotFoundPage
    }, {
      path: '*',
      redirect: 'NotFound'
    }
  ]
})
